export default {
  sulamerica: {
    local: 'http://127.0.0.1:5000',
    staging: 'https://localhost:5000',
    production: 'https://sulamericacallcenter.apps.cli.inova1.space'
  },
  dimensa: {
    local: 'http://127.0.0.1:5000',
    staging: 'https://localhost:5000',
    production: 'https://brasilprev-callcenter.apps.cli2.inova1.space'
  },
}
